import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getPermissions } from "../utils/utils";
import { sections } from "../utils/properties";

const Header = () => {
  const [permissions, setPermissions] = useState("");

  useEffect(() => {
    getPermissions().then((permissions) => {
      setPermissions(permissions);
    });
  }, []);
  return (
    <nav class="menu fixed-top text-white">
      <ol>
        {permissions.length > 0 &&
          permissions.some((e) => e.id_section === sections.ESTUDIANTES) && (
            <li class="menu-item">
              <a>
                <i className="bi-people "></i> Estudiantes
              </a>

              <ol class="sub-menu">
                {permissions.length > 0 &&
                  permissions.some(
                    (e) => e.id_section === sections.NUEVO_ESTUDIANTE
                  ) && (
                    <li class="menu-item">
                      <Link to="/estudiante">
                        <i className="bi-person"></i> Nuevo estudiante
                      </Link>
                    </li>
                  )}
                {permissions.length > 0 &&
                  permissions.some(
                    (e) => e.id_section === sections.LISTA_ESTUDIANTES
                  ) && (
                    <li class="menu-item">
                      <Link to="/estudiantes">
                        <i className="bi-people"></i> Lista de estudiantes
                      </Link>
                    </li>
                  )}
              </ol>
            </li>
          )}
        {permissions.length > 0 &&
          permissions.some((e) => e.id_section === sections.ADMINISTRACION) && (
            <li className="menu-item">
              <a>
                <i className="bi-gear"></i> Administración
              </a>
              <ol class="sub-menu">
                <li class="menu-item">
                  <Link to="/especialidades">Especialidades</Link>
                </li>
                <li class="menu-item">
                  <Link to="/agencias">Agencias</Link>
                </li>
                <li class="menu-item">
                  <Link to="/usuarios">Usuarios</Link>
                </li>
              </ol>
            </li>
          )}
        <li
          class="menu-item"
          onClick={() => {
            localStorage.removeItem("token");
            localStorage.removeItem("filters");
          }}
        >
          <Link to="/login">
            <a>
              <i className="bi bi-box-arrow-right"></i> Cerrar Sesión
            </a>
          </Link>
        </li>
      </ol>
    </nav>
    // <header className="p-3 fixed-top bg-dark text-white">
    //   <div className="container">
    //     <div className="d-flex flex-wrap align-items-center justify-content-center justify-content-lg-start">
    //       {/* <span className="navbar-brand mb-0 h1">My Diamond Central</span> */}
    //       <a
    //         href="/"
    //         className="d-flex align-items-center mb-2 mb-lg-0 text-white text-decoration-none"
    //       >
    //         {/* <svg className="bi me-2" width="40" height="32" role="img" aria-label="Bootstrap"><use xlink:href="#bootstrap"></use></svg> */}
    //       </a>

    //       <ul className="nav col-12 col-lg-auto me-lg-auto mb-2 justify-content-center mb-md-0">
    //         {permissions.length > 0 &&
    //           permissions.some(
    //             (e) => e.id_section === sections.ESTUDIANTES
    //           ) && (
    //             <li>
    //               <a
    //                 className="nav-link dropdown-toggle px-2 text-white"
    //                 id="navbarDropdown"
    //                 role="button"
    //                 data-bs-toggle="dropdown"
    //                 aria-expanded="false"
    //               >
    //                 <i className="bi-people "></i> Estudiantes
    //               </a>
    //               <ul
    //                 className="dropdown-menu"
    //                 aria-labelledby="navbarDropdown"
    //               >
    //                 {permissions.length > 0 &&
    //                   permissions.some(
    //                     (e) => e.id_section === sections.NUEVO_ESTUDIANTE
    //                   ) && (
    //                     <li>
    //                       <Link className="dropdown-item" to="/estudiante">
    //                         <i className="bi-person"></i> Nuevo estudiante
    //                       </Link>
    //                     </li>
    //                   )}
    //                 {permissions.length > 0 &&
    //                   permissions.some(
    //                     (e) => e.id_section === sections.LISTA_ESTUDIANTES
    //                   ) && (
    //                     <li>
    //                       <Link className="dropdown-item" to="/estudiantes">
    //                         <i className="bi-people"></i> Lista de estudiantes
    //                       </Link>
    //                     </li>
    //                   )}
    //               </ul>
    //             </li>
    //           )}
    //         {permissions.length > 0 &&
    //           permissions.some(
    //             (e) => e.id_section === sections.ADMINISTRACION
    //           ) && (
    //             <li className="nav-item dropdown">
    //               <a
    //                 className="nav-link dropdown-toggle px-2 text-white"
    //                 id="navbarDropdown"
    //                 role="button"
    //                 data-bs-toggle="dropdown"
    //                 aria-expanded="false"
    //               >
    //                 <i className="bi-gear"></i> Administración
    //               </a>
    //               <ul
    //                 className="dropdown-menu"
    //                 aria-labelledby="navbarDropdown"
    //               >
    //                 <li>
    //                   <Link className="dropdown-item" to="/especialidades">
    //                     Especialidades
    //                   </Link>
    //                 </li>
    //                 <li>
    //                   <Link className="dropdown-item" to="/agencias">
    //                     Agencias
    //                   </Link>
    //                 </li>
    //                 <li>
    //                   <Link className="dropdown-item" to="/usuarios">
    //                     Usuarios
    //                   </Link>
    //                 </li>
    //                 {/* <li>
    //               <a className="dropdown-item" href="#">
    //                 Usuarios
    //               </a>
    //             </li>
    //             <li>
    //               <hr className="dropdown-divider" />
    //             </li>
    //             <li>
    //               <a className="dropdown-item" href="#">
    //                 Estados estudiante
    //               </a>
    //             </li> */}
    //               </ul>
    //             </li>
    //           )}
    //       </ul>
    //       <div className="text-end">
    //         <Link to="/login">
    //           <button
    //             type="button"
    //             className="btn btn-sm btn-outline-light me-2"
    //             onClick={() => {
    //               localStorage.removeItem("token");
    //               localStorage.removeItem("filters");
    //             }}
    //           >
    //             <i className="bi bi-box-arrow-right"></i> Cerrar Sesión
    //           </button>
    //         </Link>
    //       </div>
    //     </div>
    //   </div>
    // </header>
  );
};

export default Header;
